import { connect } from 'react-redux';
import { compose } from 'redux';

import ActivationFormConfirm from '../../components/compositions/activation/ActivationFormConfirm';
import initForm from '../form/FormInitializer';
import { FORM_FIELD_SIM_STATUS } from '../../helpers/constants';
import connectSiteProvider from '../../components/basics/service/ServiceSiteConnector';
import { addProductSheetToTerms, getConsentTextById } from '../../helpers/misc';

const createFieldMap = ({ site }) => ({
  passData: {
    name: 'pass_data',
    label: getConsentTextById(site.consentTexts, 'data_handling_terms'),
    type: 'checkbox',
  },
  adConsent: {
    name: 'ad_consent',
    label: getConsentTextById(site.consentTexts, 'bew_checkout_terms'),
    type: 'checkbox',
  },
});

const mapStateToProps = (state, ownProps) => {
  const { ui } = state;
  const { formValues, fieldMap, params } = ownProps;
  const termsDataProtection = addProductSheetToTerms(
    params.termsDataProtection,
    ui,
    (formValues[FORM_FIELD_SIM_STATUS] || {}).tariff,
  );

  const data = {
    topupType: formValues[fieldMap.topupType.name],
    autoTopupType: formValues[fieldMap.autoTopupType.name],
    autoTopupMonthlyType: formValues[fieldMap.autoTopupMonthlyType.name],
    autoTopupTrigger: formValues[fieldMap.autoTopupTrigger.name],
    topupAmount: formValues[fieldMap.topupAmount.name],
    salutation: formValues[fieldMap.salutation.name],
    firstName: formValues[fieldMap.firstName.name],
    lastName: formValues[fieldMap.lastName.name],
    street: formValues[fieldMap.addressStreet.name],
    houseNumber: formValues[fieldMap.addressNumber.name],
    zip: formValues[fieldMap.addressZip.name],
    city: formValues[fieldMap.addressCity.name],
    iban: formValues[fieldMap.mediaId.name],
    paymentType: formValues[fieldMap.paymentType.name],
    simStatusResponse: formValues[fieldMap.simStatusResponse.name],
  };
  return {
    data,
    consentTexts: state.site.consentTexts,
    params: { ...params, termsDataProtection },
  };
};

// init component once, outside
const component = compose(
  connectSiteProvider(),
  connect(mapStateToProps),
  initForm(),
)(ActivationFormConfirm);

export const id = 'confirm';

const normalize = (stepConfig, stepFormValues) => {
  const { fieldMap } = stepConfig;
  const normValues = { ...stepFormValues };

  normValues[fieldMap.passData.name] = normValues[fieldMap.passData.name] ? '1' : '0';
  normValues[fieldMap.adConsent.name] = normValues[fieldMap.adConsent.name] ? '1' : '0';
  return normValues;
};

/**
 * @return {FormConfig}
 */
export const mapStateToFormConfig = (state, props) => ({
  component,
  normalize,
  fieldMap: createFieldMap(state),
  label: props.ui.guiWordVerifyData,
});

export default mapStateToFormConfig;
